import { useQuery } from '@apollo/react-hooks';
import { EXTRA_ACTIVITY } from './EXTRA_ACTIVITY_FORM.gql';
import { type GetActivity, type ActivityFormData } from './types';
import { checkInvalidDate } from '../checkInvalidDate';

export const useGetActivity = (id: string): GetActivity => {
  const {
    data: activityData,
    loading,
    error,
  } = useQuery(EXTRA_ACTIVITY, {
    variables: { id },
    skip: !id,
    fetchPolicy: 'network-only',
  });

  const activity: ActivityFormData = (activityData?.activity ??
    {}) as ActivityFormData;

  const {
    presentActivityIndicator,
    from,
    to,
    activityType,
    volunteerMode,
    organisationName,
    position,
    majorResponsibilities,
    supportingDocuments,
  } = activity ?? {};

  const activityFormData: ActivityFormData = {
    presentActivityIndicator: presentActivityIndicator ?? false,
    from: checkInvalidDate(from) ? null : from,
    to: checkInvalidDate(to) ? null : to,
    activityType,
    volunteerMode,
    organisationName,
    position,
    majorResponsibilities,
    supportingDocuments: supportingDocuments ?? [],
  };

  return { activityFormData, loading, error };
};
